import { Component } from 'react';

export default class Button extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleKeyPress(event) {
    if (event.keyCode === 10 || event.keyCode === 13) {
      this.props.onClick();
    }
  }

  render() {
    const extraProps = {};

    if (this.props.id) {
      extraProps.id = this.props.id;
    }

    if (this.props.disabled) {
      extraProps.disabled = this.props.disabled;
    }

    return (
      <div
        {...extraProps}
        role="button"
        tabIndex="0"
        onKeyDown={this.handleKeyPress.bind(this)}
        onClick={this.props.onClick}
        className={`btn ${this.props.className}`}
      >
        {this.props.text}
      </div>
    );
  }
}
